<template>
  <!-- 客户管理-客户资料库 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="tableData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      :permission="permissionList"
      :before-open="beforeOpenForm"
      :before-close="beforeCloseForm"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="menuLeft">
        <el-button
          v-if="permissionList.importBtn"
          type="success"
          plain
          size="small"
          icon="el-icon-upload2"
          @click="isImportDialogShow = true"
        >
          导入
        </el-button>
        <el-button
          v-if="permissionList.exportBtn"
          type="success"
          plain
          size="small"
          icon="el-icon-download"
          @click="exportData"
        >
          导出
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      append-to-body
      :visible.sync="isImportDialogShow"
      :close-on-click-modal="false"
      width="400px"
      accept="vnd.ms-excel"
    >
      <ImportFile
        title="导入客户资料"
        exportApi="/api/v4ward/callcenter/customer/exportTemplate"
        importApi="/api/v4ward/callcenter/customer/import"
        @uploadCallBack="importCallBack"
      ></ImportFile>
    </el-dialog>
  </basic-container>
</template>

<script>
import ImportFile from '@/views/nursingHome/initData/importFile';
import qs from 'qs';
import { mapGetters } from 'vuex';
import { getToken } from '@/util/auth';
import { getProjectListApi } from '@/api/call-system/index';
import {
  getPageListApi,
  addApi,
  updateApi,
  removeApi,
} from '@/api/call-system/customer-manage/customer-list';

export default {
  components: {
    ImportFile,
  },
  data() {
    return {
      oldProjectId: '', // 旧项目id，重置搜索条件和新增时需要使用
      projectList: [], // 项目列表
      searchForm: {}, // 搜索条件
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      isImportDialogShow: false, // 导入弹框是否显示着
      loading: false, // 是否正在加载表格数据
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        dialogClickModal: false,
        searchMenuSpan: 12,
        searchLabelWidth: 100,
        labelWidth: 100,
        menuWidth: 150,
        column: [
          {
            label: '项目名称',
            prop: 'projectId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            type: 'select',
            hide: true,
            showColumn: false,
            display: false,
            // search: true,
            // searchClearable: false,
          },
          {
            label: '姓名',
            prop: 'name',
            span: 8,
            search: true,
            maxlength: 20,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入姓名',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '联系电话',
            prop: 'phone',
            span: 8,
            search: true,
            maxlength: 11,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入联系电话',
                trigger: 'blur',
              },
              {
                pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
                message: '请输入正确的联系电话',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '客户性别',
            prop: 'sex',
            type: 'select',
            span: 8,
            dicUrl: '/api/blade-system/dict/dictionary?code=sex',
            dataType: 'string',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择性别',
                trigger: 'change',
              },
            ],
          },
          {
            label: '客户类型',
            prop: 'custType',
            type: 'select',
            span: 8,
            dicUrl: '/api/blade-system/dict/dictionary?code=telephone_customer_type',
            dataType: 'string',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择客户类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '证件类型',
            prop: 'certType',
            type: 'select',
            span: 8,
            dicUrl: '/api/blade-system/dict/dictionary?code=telephone_customer_certificate_type',
            dataType: 'string',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '证件号',
            prop: 'certNo',
            span: 8,
            maxlength: 30,
            showWordLimit: true,
          },
          {
            label: '客户地址',
            prop: 'addr',
            span: 24,
            maxlength: 50,
            showWordLimit: true,
            overHidden: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.callSystem_customerManage_customerList_add, false),
        delBtn: this.vaildData(this.permission.callSystem_customerManage_customerList_del, false),
        editBtn: this.vaildData(this.permission.callSystem_customerManage_customerList_edit, false),
        importBtn: this.vaildData(
          this.permission.callSystem_customerManage_customerList_import,
          false
        ),
        exportBtn: this.vaildData(
          this.permission.callSystem_customerManage_customerList_export,
          false
        ),
      };
    },
  },
  created() {
    getProjectListApi().then(({ data }) => {
      this.projectList = data || [];
      if (this.projectList.length > 0) {
        this.findObject(this.tableOption.column, 'projectId').dicData = this.projectList;
        this.searchForm.projectId = this.projectList[0].id;
        this.loadData();
      }
    });
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 336; // 表格区域初始化高度
      const searchH = 56; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    /* 加载表格数据 */
    loadData(page) {
      if (!this.searchForm.projectId) return;
      this.oldProjectId = this.searchForm.projectId;
      page = page || this.tablePage;
      this.loading = true;
      getPageListApi(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.searchForm = {
        projectId: this.oldProjectId,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    beforeOpenForm(done, type) {
      this.needCloseConfirm = true;
      if (type == 'view') {
        this.needCloseConfirm = false;
      }
      done();
    },
    beforeCloseForm(done, type) {
      if (!this.needCloseConfirm) {
        done();
      } else {
        this.$confirm('确定关闭页面?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          done();
        });
      }
    },
    rowSave(row, done, loading) {
      addApi(row).then(
        () => {
          this.loadData();
          this.$message.success('操作成功!');
          this.needCloseConfirm = false;
          done();
        },
        () => {
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      updateApi(row).then(
        () => {
          this.loadData();
          this.$message.success('操作成功!');
          this.needCloseConfirm = false;
          done();
        },
        () => {
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return removeApi({
            id: row.id,
          });
        })
        .then(() => {
          this.loadData();
          this.$message.success('操作成功!');
        });
    },
    /* 导入成功的回调 */
    importCallBack(ret) {
      if (ret) {
        this.isImportDialogShow = false;
        this.tablePage.currentPage = 1;
        this.tablePage.total = 0;
        this.tableData = [];
        this.loadData();
      }
    },
    /* 导出 */
    exportData() {
      let params = qs.stringify(this.searchForm);
      window.open(
        `/api/v4ward/callcenter/customer/exportData?${
          this.website.tokenHeader
        }=${getToken()}&${params}`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
